/* ==========================================================================
   WSPR panels – assets/wspr-panels.js (all pages, defer)
   - Search panel: opens from the header icon or "/", results as you type through
     Shopify's predictive search endpoint rendered by sections/wspr-search-results.liquid,
     recent searches on this device, no-result WhatsApp with the query.
   - Cart drawer: opens from the bag icon or after the theme adds to cart; quantity,
     remove and note go through the Cart AJAX API and the section is re-rendered.
   - Cart page: same, plus discount code and recommendations.
   ========================================================================== */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  var routeRoot = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var hd = d.querySelector('[data-wspr-hd]');

  function theme() { return (hd && hd.getAttribute('data-theme')) || 'light'; }
  function lock(on) { root.classList.toggle('wspr-panel-open', on); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function closeHeaderMenus() {
    if (!hd) return;
    hd.classList.remove('is-drawer', 'is-mega');
    var b = hd.querySelector('[data-wspr-burger]'); if (b) b.setAttribute('aria-expanded', 'false');
    var s = hd.querySelector('[data-wspr-shop]'); if (s) s.setAttribute('aria-expanded', 'false');
    hd.classList.remove('is-open');
    var scrim = d.querySelector('[data-wspr-scrim]'); if (scrim) scrim.classList.remove('is-on');
    root.classList.remove('wspr-menu-open', 'wspr-lock');
  }
  function sectionInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  /* ======================= SEARCH ======================= */
  var sp = d.querySelector('[data-wspr-search]');
  if (sp) {
    var input = sp.querySelector('[data-wspr-search-input]');
    var results = sp.querySelector('[data-wspr-search-results]');
    var empty = sp.querySelector('[data-wspr-search-empty]');
    var hint = sp.querySelector('[data-wspr-search-hint]');
    var recentBox = sp.querySelector('[data-wspr-search-recent]');
    var recentList = sp.querySelector('[data-wspr-search-recent-list]');
    var waBase = sp.getAttribute('data-wa') || '';
    var timer = null, ctrl = null, lastQ = '';
    var KEY = 'wspr-recent-searches';

    function recent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function remember(q) {
      q = (q || '').trim(); if (!q) return;
      try {
        var r = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
        r.unshift(q); localStorage.setItem(KEY, JSON.stringify(r.slice(0, 5)));
      } catch (e) {}
    }
    function renderRecent() {
      if (!recentBox) return;
      var r = recent();
      recentBox.hidden = !r.length;
      recentList.innerHTML = r.map(function (q) {
        return '<button type="button" class="wspr-sp__recent" data-q="' + esc(q) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' + esc(q) + '</button>';
      }).join('');
    }
    function showEmpty() {
      results.hidden = true; empty.hidden = false;
      if (hint) hint.textContent = 'Type a piece, a brand, a designer’s name or a product code';
      sp.classList.remove('has-q');
    }
    function search(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      results.classList.add('is-loading');
      var url = routeRoot + 'search/suggest?q=' + encodeURIComponent(q) + '&section_id=wspr-search-results' +
        '&resources[type]=product,collection,page&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,tag';
      fetch(url, { signal: ctrl.signal }).then(function (r) { return r.text(); }).then(function (html) {
        var frag = sectionInner(html, '[data-wspr-sr]');
        if (!frag) return;
        results.innerHTML = '';
        results.appendChild(frag);
        results.hidden = false; empty.hidden = true;
        results.classList.remove('is-loading');
        var any = frag.getAttribute('data-any') === 'true';
        if (hint) hint.textContent = any ? 'Showing what matches “' + q + '” as you type' : 'No match yet — try a brand, a category or a product code';
        var wa = frag.querySelector('[data-wspr-sr-wa]');
        if (wa) wa.setAttribute('href', waBase.replace('WSPR_Q', encodeURIComponent('I searched for “' + q + '” and couldn’t find it. Can you help?').replace(/%20/g, '%20')));
      }).catch(function () {});
    }
    function onInput() {
      var q = input.value.trim();
      sp.classList.toggle('has-q', q.length > 0);
      clearTimeout(timer);
      if (!q) { lastQ = ''; if (ctrl) ctrl.abort(); showEmpty(); return; }
      if (q === lastQ) return;
      lastQ = q;
      timer = setTimeout(function () { search(q); }, 180);
    }
    function openSearch() {
      closeHeaderMenus();
      sp.setAttribute('data-theme', theme());
      sp.classList.add('is-open'); sp.setAttribute('aria-hidden', 'false');
      lock(true);
      renderRecent();
      [].forEach.call(d.querySelectorAll('[data-wspr-search-open]'), function (b) { b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { input.focus(); input.select(); }, 60);
      if (!input.value.trim()) showEmpty();
    }
    function closeSearch() {
      if (!sp.classList.contains('is-open')) return;
      sp.classList.remove('is-open'); sp.setAttribute('aria-hidden', 'true');
      lock(false);
      [].forEach.call(d.querySelectorAll('[data-wspr-search-open]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    w.wsprOpenSearch = openSearch;

    d.addEventListener('click', function (e) {
      var t = e.target.closest('[data-wspr-search-open]');
      if (t) { e.preventDefault(); if (sp.classList.contains('is-open')) closeSearch(); else openSearch(); return; }
      if (e.target.closest('[data-wspr-search-close]')) { e.preventDefault(); closeSearch(); return; }
      if (e.target.closest('[data-wspr-search-clear]')) { input.value = ''; onInput(); input.focus(); return; }
      var rc = e.target.closest('[data-wspr-search-recent-clear]');
      if (rc) { try { localStorage.removeItem(KEY); } catch (x) {} renderRecent(); return; }
      var rb = e.target.closest('.wspr-sp__recent');
      if (rb) { input.value = rb.getAttribute('data-q'); onInput(); input.focus(); return; }
      var pick = e.target.closest('[data-wspr-sr-pick]');
      if (pick) remember(pick.getAttribute('data-wspr-sr-pick'));
    });
    input.addEventListener('input', onInput);
    sp.querySelector('[data-wspr-search-form]').addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); return; }
      remember(q);
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sp.classList.contains('is-open')) { closeSearch(); return; }
      if (e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey) {
        var a = d.activeElement, tag = a && a.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (a && a.isContentEditable)) return;
        e.preventDefault(); openSearch();
      }
    });
    // keep the panel's tint in step with the header while open
    if (hd) new MutationObserver(function () { if (sp.classList.contains('is-open')) sp.setAttribute('data-theme', theme()); }).observe(hd, { attributes: true, attributeFilter: ['data-theme'] });
  }

  /* ======================= CART ======================= */
  var cd = d.querySelector('[data-wspr-cd]');
  var cartPage = d.querySelector('[data-wspr-cart]');
  function sectionIds() {
    var ids = [];
    if (cd) ids.push(cd.getAttribute('data-section-id'));
    if (cartPage) ids.push(cartPage.getAttribute('data-section-id'));
    return ids;
  }
  function updateCount(n) {
    [].forEach.call(d.querySelectorAll('.wspr-hd__count, xo-cart-size'), function (el) { el.textContent = n; });
    if (cd) cd.setAttribute('data-count', n);
  }
  function applySections(sections) {
    if (!sections) return;
    var openNow = cd && cd.classList.contains('is-open');
    if (cd) {
      var html = sections[cd.getAttribute('data-section-id')];
      if (html) {
        var fresh = sectionInner(html, '[data-wspr-cd]');
        if (fresh) {
          cd.innerHTML = fresh.innerHTML;
          cd.setAttribute('data-count', fresh.getAttribute('data-count'));
          cd.setAttribute('data-wa', fresh.getAttribute('data-wa') || cd.getAttribute('data-wa'));
          if (openNow) cd.classList.add('is-open');
        }
      }
    }
    if (cartPage) {
      var html2 = sections[cartPage.getAttribute('data-section-id')];
      if (html2) {
        var fresh2 = sectionInner(html2, '[data-wspr-cart]');
        if (fresh2) {
          var recs = cartPage.querySelector('[data-wspr-cart-recs]');
          cartPage.innerHTML = fresh2.innerHTML;
          cartPage.setAttribute('data-count', fresh2.getAttribute('data-count'));
          var slot = cartPage.querySelector('[data-wspr-cart-recs]');
          if (recs && slot && recs.innerHTML) { slot.innerHTML = recs.innerHTML; slot.hidden = false; }
          else loadRecs();
        }
      }
    }
  }
  function busy(on) { if (cd) cd.classList.toggle('is-busy', on); if (cartPage) cartPage.classList.toggle('is-busy', on); }

  function cartRequest(path, body) {
    body.sections = sectionIds().join(',');
    body.sections_url = w.location.pathname;
    return fetch(routeRoot + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function refreshCart() {
    if (!sectionIds().length) return Promise.resolve();
    // a POST is never cached: the sections come back rendered with the cart as it is now
    return cartRequest('cart/update.js', {}).then(function (cart) {
      if (cart && cart.sections) applySections(cart.sections);
      if (cart && typeof cart.item_count === 'number') updateCount(cart.item_count);
    }).catch(function () {});
  }
  function changeLine(line, qty) {
    busy(true);
    return cartRequest('cart/change.js', { line: line, quantity: qty }).then(function (cart) {
      busy(false);
      if (cart && cart.sections) applySections(cart.sections);
      if (cart && typeof cart.item_count === 'number') updateCount(cart.item_count);
    }).catch(function () { busy(false); });
  }
  var noteTimer = null;
  function saveNote(el) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(routeRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: el.value }) })
        .then(function () {
          var s = el.parentElement.querySelector('[data-wspr-note-saved]');
          if (s) { s.classList.add('is-on'); setTimeout(function () { s.classList.remove('is-on'); }, 1600); }
          [].forEach.call(d.querySelectorAll('[data-wspr-cart-note]'), function (o) { if (o !== el) o.value = el.value; });
        }).catch(function () {});
    }, 500);
  }
  function waHref(scope) {
    var base = scope.getAttribute('data-wa') || '';
    var lines = [].map.call(scope.querySelectorAll('[data-wspr-line]'), function (l) {
      var v = l.getAttribute('data-variant'), sku = l.getAttribute('data-sku');
      return '· ' + l.getAttribute('data-qty') + ' × ' + l.getAttribute('data-title') + (v ? ' – ' + v : '') + (sku ? ' (' + sku + ')' : '');
    });
    var total = scope.querySelector('.wspr-cd__total, .wspr-cart__r span:last-child');
    var msg = 'I have these in my cart:\n' + lines.join('\n') + (total ? '\nSubtotal ' + total.textContent.trim() + ' excl. VAT.' : '') + '\n\nCould you confirm lead times and quote delivery?';
    return base.replace('WSPR_CART', encodeURIComponent(msg).replace(/%20/g, '%20'));
  }
  function openCart() {
    if (!cd) return;
    closeHeaderMenus();
    if (sp) sp.classList.remove('is-open');
    cd.setAttribute('data-theme', theme());
    cd.classList.add('is-open'); cd.setAttribute('aria-hidden', 'false');
    lock(true);
    var x = cd.querySelector('.wspr-cd__x'); if (x) setTimeout(function () { x.focus(); }, 80);
  }
  function closeCart() {
    if (!cd || !cd.classList.contains('is-open')) return;
    cd.classList.remove('is-open'); cd.setAttribute('aria-hidden', 'true');
    lock(false);
  }
  w.wsprOpenCart = openCart;
  w.wsprRefreshCart = refreshCart;

  d.addEventListener('click', function (e) {
    var open = e.target.closest('[data-wspr-cart-open]');
    if (open && cd && !cartPage) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-wspr-cd-close]')) { e.preventDefault(); closeCart(); return; }
    var q = e.target.closest('[data-wspr-qty]');
    if (q) {
      e.preventDefault();
      var p = q.getAttribute('data-wspr-qty').split(':');
      changeLine(parseInt(p[0], 10), Math.max(0, parseInt(p[1], 10)));
      return;
    }
    var wa = e.target.closest('[data-wspr-cart-wa]');
    if (wa) { var scope = wa.closest('[data-wspr-cd], [data-wspr-cart]'); if (scope) wa.setAttribute('href', waHref(scope)); }
  });
  d.addEventListener('input', function (e) { if (e.target.matches('[data-wspr-cart-note]')) saveNote(e.target); });
  d.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-wspr-discount]');
    if (!f) return;
    e.preventDefault();
    var code = (f.querySelector('input').value || '').trim();
    if (!code) { f.classList.add('is-error'); return; }
    w.location.href = routeRoot + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routeRoot + 'cart');
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  // the theme's add-to-cart (xo-cart-add) writes to its own store: open our drawer when a piece lands
  var wasAdded = false, tries = 0;
  (function hook() {
    if (typeof w.cartSubscribe === 'function') {
      w.cartSubscribe(function (state) {
        var added = !!state.isAdded;
        if (added && !wasAdded) { refreshCart().then(openCart); }
        wasAdded = added;
        if (typeof state.size === 'number' && !cd) updateCount(state.size);
      });
    } else if (tries++ < 40) setTimeout(hook, 250);
  })();

  // recommendations on the cart page
  function loadRecs() {
    if (!cartPage) return;
    var slot = cartPage.querySelector('[data-wspr-cart-recs]');
    var pid = cartPage.getAttribute('data-first-product');
    if (!slot || !pid) { if (slot) slot.hidden = true; return; }
    fetch(routeRoot + 'recommendations/products?section_id=wspr-cart-recs&product_id=' + pid + '&limit=4&intent=related')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var frag = sectionInner(html, '.wspr-recs');
        if (!frag) { slot.hidden = true; return; }
        slot.innerHTML = ''; slot.appendChild(frag); slot.hidden = false;
      }).catch(function () {});
  }
  loadRecs();
})();

/* ==========================================================================
   NEWSLETTER POPUP – shows on exit intent (desktop) or after N% scroll, once every N days,
   never once subscribed, never over an open panel or menu. No ✕, no scrim click, no Escape:
   it closes only through the dismiss link (or the button on the success state).
   ========================================================================== */
(function () {
  var d = document, w = window, root = d.documentElement;
  var nl = d.querySelector('[data-wspr-nl]');
  if (!nl || nl.getAttribute('data-enabled') === 'false') return;
  var hd = d.querySelector('.wspr-hd');
  var KEY = 'wspr-nl';
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
  var save = function (o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} };
  var state = read(), open = false, fired = false;
  var days = parseFloat(nl.getAttribute('data-days')) || 14;
  var scrollPct = parseFloat(nl.getAttribute('data-scroll')) || 0;
  var exit = nl.getAttribute('data-exit') !== 'false';
  var minMs = (parseFloat(nl.getAttribute('data-min-seconds')) || 0) * 1000;
  var loadedAt = Date.now();
  var done = nl.querySelector('[data-wspr-nl-done]');
  var designMode = !!(w.Shopify && w.Shopify.designMode);

  function show() {
    if (open) return;
    open = true; fired = true;
    nl.setAttribute('data-theme', (hd && hd.getAttribute('data-theme')) || 'light');
    nl.classList.add('is-open'); nl.setAttribute('aria-hidden', 'false');
    root.classList.add('wspr-panel-open');
    state.shown = Date.now(); save(state);
    var input = nl.querySelector('.wspr-nl__input');
    if (input && w.matchMedia('(min-width: 721px)').matches) setTimeout(function () { input.focus(); }, 450);
    detach();
  }
  function hide() {
    if (!open) return;
    open = false;
    nl.classList.remove('is-open'); nl.setAttribute('aria-hidden', 'true');
    root.classList.remove('wspr-panel-open');
  }
  function blocked() {
    return root.classList.contains('wspr-panel-open') || root.classList.contains('wspr-menu-open') || d.body.classList.contains('wspr-tpl-cart');
  }
  function ready() { return Date.now() - loadedAt >= minMs && !blocked() && !fired; }
  function onScroll() {
    if (!ready()) return;
    var max = d.documentElement.scrollHeight - w.innerHeight;
    if (max <= 0) return;
    if ((w.scrollY / max) * 100 >= scrollPct) show();
  }
  function onOut(e) {
    if (!ready()) return;
    if (!e.relatedTarget && e.clientY <= 0) show();
  }
  function detach() {
    w.removeEventListener('scroll', onScroll);
    d.removeEventListener('mouseout', onOut);
  }

  nl.addEventListener('click', function (e) { if (e.target.closest('[data-wspr-nl-close]')) { hide(); } });
  var form = nl.querySelector('form');
  if (form) form.addEventListener('submit', function () { state.subscribed = true; save(state); });

  w.wsprOpenNewsletter = show;         // for testing / manual triggers

  // just subscribed (Shopify reloads the page with the success state rendered)
  if (done) { state.subscribed = true; save(state); show(); return; }
  if (designMode) return;              // the theme editor shows sections itself
  if (state.subscribed) return;
  if (state.shown && Date.now() - state.shown < days * 864e5) return;

  if (scrollPct > 0) w.addEventListener('scroll', onScroll, { passive: true });
  if (exit) d.addEventListener('mouseout', onOut);
})();
